import React  from 'react';
import styled from 'styled-components';
import { TextBtn2 } from '../Inputs/TextBtn2';
import { Link } from 'react-router-dom';
const Styles = styled.div`
  margin: 1rem var(--universal-pad);
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: calc(100% - calc(var(--universal-pad) * 2));
  .main-text {
    flex-grow: 1;
    font-size: 1rem;
    font-weight: 500;
  }
  a {
    min-width: 200px;
    display: block;
    text-decoration: none;
    color: inherit;
    display: flex;
    justify-content: center;
    .btn {
      max-width: 300px;
    }
  }
  @media screen and (max-width: 850px) {
    flex-direction: column;
  }
`
export default function CtaTextInPage32 (props){
  const {data: dataRaw, lan} = props;
  const data = JSON.parse(dataRaw);
  return (
    <Styles>
      <div className='main-text'>
        {data.text}
      </div>
      <Link to={"/" + lan.filename + data["link-btn"]}>
        <TextBtn2
          classname={"btn"}
          text={data["text-btn"]}
          newType={2}
        />
      </Link>
    </Styles>
  )
}

